module.exports = __webpack_public_path__ + "static/img/sikao.53c2d92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test/sikao.jpg
// module id = oeAu
// module chunks = 1